<template>
  <div class="app-wizard cs-scroll-style">
    <h4>{{ $tI_G('Left panel Subtitle') }}</h4>
    <div class="wizard-container">
      <div class="wizard-card">
        <div class="icon">
         <img src="@/assets/img/ancient-origin-breakdown.png"/>
        </div>
        <h3>{{ $tI('Ancient Origins Breakdown') }}</h3>
        <p>{{ $tI('Right panel Ancient Origins Breakdown box ') }}</p>
        <div class="btn-container">
          <button class="info-modal-btn single-btn" @click="$router.push({ name: 'periodical' })"
            v-click-track="'Iframe.ancientDnaAncientOriginsBreakdownExploreClick'" >
            {{ $tI_G('Explore CTA') }}
          </button>
        </div>
      </div>

      <div class="wizard-card">
        <div class="icon">
          <img src="@/assets/img/hg-farmer.png"/>
        </div>
        <h3>{{ $tI('Hunter Gatherer and Farmer Breakdown') }}</h3>
        <p>{{ $tI_G('Right panel Hunter Gatherer and Farmer Breakdown box') }}</p>
        <div class="btn-container">
          <button class="info-modal-btn single-btn" @click="$router.push({ name: 'hg-farmer' })"
            v-click-track="'Iframe.ancientDnaHunterGathererAndFarmerExploreClick'">
            {{ $tI_G('Explore CTA') }}
          </button>
        </div>
      </div>

      <div class="wizard-card">
        <div class="icon">
          <img src="@/assets/img/closest-population.png"/>
        </div>
        <h3>{{ $tI('Closest Populations') }}</h3>
        <p>{{ $tI_G('Closest Populations Subtitle') }}</p>
        <div class="btn-container">
          <button class="info-modal-btn single-btn" @click="$router.push({ name: 'closest-populations' })"
            v-click-track="'Iframe.ancientDnaClosestPopulationsExploreClick'">
            {{ $tI_G('Explore CTA') }}
          </button>
        </div>
      </div>

      <div class="wizard-card">
        <div class="icon">
          <img src="@/assets/img/notable-individual.png"/>
        </div>
        <h3>{{ $tI('Notable Individuals') }}</h3>
        <p>{{ $tI_G('Notable Individual Subtitle') }}</p>
        <div class="btn-container">
          <button class="info-modal-btn single-btn" @click="$router.push({ name: 'notable-individuals' })"
            v-click-track="'Iframe.ancientDnaNotableConnectionsExploreClick'">
            {{ $tI_G('Explore CTA') }}
          </button>
        </div>
      </div>

      <div class="wizard-card">
        <div class="icon">
          <img src="@/assets/img/genetic-similarities.png"/>
        </div>
        <h3>{{ $tI('Genetic Similarities Breakdown') }}</h3>
        <p>{{ $tI_G('Right panel Genetic Similarities Breakdown box') }}</p>
        <div class="btn-container">
          <button class="info-modal-btn single-btn" @click="$router.push({ name: 'genetic-similarities' })" 
            v-click-track="'Iframe.ancientDnaGeneticSimilaritiesExploreClick'">
            {{ $tI_G('Explore CTA') }}
          </button>
        </div>
      </div>

      <div class="wizard-card">
        <div class="icon">
          <img src="@/assets/img/pca-plot.png"/>
        </div>
        <h3>{{ $tI('Genetic Distance Maps Title') }}</h3>
        <p>{{ $tI_G('Right panel Genetic Distance Maps box') }}</p>
        <div class="btn-container">
          <button class="info-modal-btn single-btn" @click="$router.push({ name: 'pca-plot' })" 
            v-click-track="'Iframe.ancientDnaGeneticDistanceMapsExploreClick'">
            {{ $tI_G('Explore CTA') }}
          </button>
        </div>
      </div>

      <div class="wizard-card">
        <div class="icon">
          <img src="@/assets/img/sample-database.png"/>
        </div>
        <h3>{{ $tI('Sample Database') }}</h3>
        <p> {{ $tI_G('Right panel Sample Database box') }}</p>
        <div class="btn-container">
          <button class="info-modal-btn single-btn" @click="$router.push({ name: 'sample-database' })" 
            v-click-track="'Iframe.ancientDnaSampleDatabaseExploreClick'">
            {{ $tI_G('Explore CTA') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
    };
  },
};
</script>    

<style lang="scss" scoped>
.app-wizard {
  flex: 1;
  overflow-y: auto;
  padding: 50px;

  .wizard-container {
    margin-top: 30px;
  }
  .wizard-card {
    background-color: var(--white-100);
    border-radius: 30px;
    padding: 28px;
    margin-bottom: 30px;

    .icon {
      margin-bottom: 20px;
      margin-left: -10px;
      img {
        height: 76px;
      }
    }
    h3 {
      font-weight: bold;
    }
    p {
      color: var(--black-70);
      font-size: 0.93rem;
      line-height: 1.35rem;
    }

    .btn-container {
      margin-top: 20px;
    }
  }
}
</style>
